import React from 'react';

import {
  Body,
  Card,
  Header,
  HeaderProgress,
  HeaderTitle,
  ProgressCurrent,
  TaskStrong
} from '../styled';
import { Task, TaskItem } from '../task-item';
import { useUnlockGift, CriteriaTask } from './useUnlockGift';

interface UnlockGiftProps {
  tasks?: Task[];
}

const DEFAULT_TASKS: CriteriaTask[] = [
  {
    description: (
      <>
        Complete at least <TaskStrong>4 new tasks</TaskStrong>
      </>
    ),
    criteriaKey: 'quiz',
    completed: false
  },
  {
    description: (
      <>
        Send <TaskStrong>800 FAN</TaskStrong> or more to support any Buildathon project
      </>
    ),
    criteriaKey: 'vote',
    completed: false
  }
];

export const UnlockGift: React.FC<UnlockGiftProps> = ({ tasks = DEFAULT_TASKS }) => {
  const { resolvedTasks, completedCount, totalCount, isAllCompleted } = useUnlockGift(tasks);

  return (
    <Card>
      <Header gap={8}>
        <HeaderTitle weight={3} size="lg">
          Unlock your gift
        </HeaderTitle>

        <HeaderProgress>
          (<ProgressCurrent completed={isAllCompleted}>{completedCount}</ProgressCurrent>/
          {totalCount})
        </HeaderProgress>
      </Header>

      <Body>
        {resolvedTasks.map((task, idx) => {
          const criteriaTask = task as CriteriaTask;
          const key = criteriaTask.criteriaKey
            ? `task-${criteriaTask.criteriaKey}-${idx}`
            : `task-${idx}`;
          return <TaskItem key={key} task={task} />;
        })}
      </Body>
    </Card>
  );
};
